import React from 'react';

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import './SelectUser.css';

/**
 * props:
 * id
 * users
 * userMap
 * noneLabel
 * selected
 * edit
 * onSelect
 */
class SelectUser extends React.Component {
    constructor(props) {
        super(props);
        // console.log("SelectUser:", props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    render() {
        let users = this.props.users || [];
        let edit = this.props.edit;

        let sel = this.props.selected;
        let selected = typeof sel === 'string' ? this.props.userMap[sel] : sel;
        // console.log("SelectUser selected:", selected);

        return (
            edit ?
                <Select
                    id="selected"
                    className="select"
                    value={selected ? selected.type + '/' + selected.id : "null"}
                    onChange={e => this.handleSelect(e.target.value)}
                >
                    <MenuItem key="null" value={null}>{this.props.noneLabel || 'None'}</MenuItem>
                    {
                        users.map((user) => {
                            return (
                                <MenuItem key={user.id} value={user.type + '/' + user.id}>{user.name}</MenuItem>
                            );
                        })
                    }
                </Select> :
                <span
                    className="selected"
                    onClick={this.props.onClick}
                >
                    {selected ? selected.name : (this.props.noneLabel || 'None')}
                </span>
        );
    }

    handleSelect(value) {
        let userMap = this.props.userMap || {};
        let user = value ? userMap[value] : null;

        this.setState({
            selected: user
        });

        this.props.onSelect(this.props.id, user);
    }
}

export default SelectUser;
